import { Button, Flex } from '@mantine/core';
import { ReactNode } from 'react';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const ReportHistoryContainer = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { t } = useTranslation('reports');
  const navigate = useNavigate();
  return (
    <Flex
      direction={'row'}
      justify={'center'}
      style={{ backgroundColor: 'var(--mantine-color-clinicalWhite-0)' }}
    >
      <div
        style={{
          width: '100%',
          backgroundColor: 'var(--mantine-color-clinicalWhite-0)',
          height: '100%',
          maxWidth: 1000,
        }}
      >
        <Button
          variant={'list'}
          style={{ paddingLeft: 'var(--mantine-spacing-md)' }}
          onClick={() => void navigate('/reports/overview')}
          leftSection={
            <ArrowBackIosNewOutlinedIcon
              style={{ fontSize: 'var(--mantine-fontSize-md)' }}
            />
          }
        >
          <b>{t('reports:to_overview')}</b>
        </Button>
        {children}
      </div>
    </Flex>
  );
};
